module.exports = __webpack_public_path__ + "img/cadreSurvol.7f8c998c.png";